/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useRef, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import Cropper from "react-cropper";
import classnames from "classnames";
import "cropperjs/dist/cropper.css";

import CustomButton from "../CustomButton";

import {
  INITIAL_CROPPER_STATE,
  MAX_IMAGE_WIDTH,
  MAX_IMAGE_HEIGHT,
  MIN_CROP_BOX_WIDTH,
  MIN_CROP_BOX_HEIGHT,
} from "./constants/index";

export const ImageCropper = ({
  selectedImage,
  onCropImage,
  onCloseCropper,
  isRoundedCropper,
}) => {
  const [state, setState] = useState(INITIAL_CROPPER_STATE);
  const cropper = useRef(null);

  const cropImage = useCallback(() => {
    if (!cropper?.current?.cropper?.getCroppedCanvas()) return;

    cropper.current.cropper
      .getCroppedCanvas({
        maxWidth: MAX_IMAGE_WIDTH,
        maxHeight: MAX_IMAGE_HEIGHT,
      })
      .toBlob((blob) => onCropImage(blob));
  }, [onCropImage]);

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      src: !selectedImage ? "" : selectedImage.preview,
    }));
  }, [selectedImage]);

  return (
    <>
      <div
        className={classnames("img-container position-relative mb-2", {
          "rounded-cropper": isRoundedCropper,
        })}
      >
        <Cropper
          style={{ height: 400, width: "100%" }}
          aspectRatio={state.ratio1 / state.ratio2}
          preview=".img-preview"
          src={state.src}
          ref={cropper}
          zoomTo={state.zoom}
          dragMode={state.dragMode}
          rotateTo={state.rotate}
          scaleX={state.scaleX}
          scaleY={state.scaleY}
          enable={state.enable}
          disable={state.disable}
          viewMode={state.viewMode}
          minCropBoxWidth={MIN_CROP_BOX_WIDTH}
          minCropBoxHeight={MIN_CROP_BOX_HEIGHT}
          center
          guides
        />
        <div className="cropper-zoom d-flex flex-column position-absolute">
          <button className="cropper-zoom__button--round d-flex p-0 rounded-circle" onClick={() => cropper.current.cropper?.zoom(0.1)}>
            <i className="bx bx-plus m-auto" />
          </button>
          <button className="cropper-zoom__button--round d-flex mt-2 p-0 rounded-circle" onClick={() => cropper.current.cropper?.zoom(-0.1)}>
            <i className="bx bx-minus m-auto" />
          </button>
        </div>
      </div>
      <div className="modal-buttons-wrapper">
        <CustomButton
          className='outline-primary'
          onClick={onCloseCropper}
        >
          Cancel
        </CustomButton>
        <CustomButton
          className='filled-primary'
          onClick={cropImage}
        >
          Save
        </CustomButton>
      </div>
    </>
  );
};

ImageCropper.propTypes = {
  selectedImage: PropTypes.any,
  isRoundedCropper: PropTypes.bool,
  onCropImage: PropTypes.func,
  onCloseCropper: PropTypes.func,
};
